// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"348d7b08","495":"9de43099","580":"83908762"}[chunkId] + ".chunk.css";
};